import { Component, Element, Prop, State, h } from '@stencil/core';
import { MenuItem, MenuItemHandler } from '../../../public-interfaces';
/**
 * @internal
 */
@Component({
  tag: 'drop-down',
  styleUrl: 'drop-down.css',
  shadow: true,
})
export class DropDown {
  @Prop() menuItems: MenuItem[] = [];
  @State() isOpen: boolean = false;
  @Element() hostElement: HTMLElement;

  componentDidLoad() {
    const slot = this.hostElement.shadowRoot.querySelector('slot[name="trigger"]') as HTMLSlotElement;
    slot.addEventListener('click', this.toggleOpen);
  }

  toggleOpen = () => {
    this.isOpen = !this.isOpen;
  };

  handleMenuItemClick = (itemHandler: MenuItemHandler) => {
    this.toggleOpen();
    itemHandler();
  };

  render() {
    return (
      <div class="triggerWrapper">
        <slot name="trigger"></slot>
        {this.isOpen ? (
          <menu>
            {this.menuItems?.map(menuItem => {
              return (
                <div class="menuItem" onClick={() => this.handleMenuItemClick(menuItem.handler)}>
                  <img src={menuItem.icon}></img>
                  <p>{menuItem.label}</p>
                </div>
              );
            })}
          </menu>
        ) : null}
      </div>
    );
  }
}
